/***
*
*   EVENT/GROUPS
*   List the events grouped by name
*
**********/
import { useState, useEffect } from 'react';
import { Animate, Card, Table, useAPI, CustomSearch, useEvents } from 'components/lib';

export function EventGroups(props) {

  // states 
  const [search] = useState('');
  const [events, setEvents] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(null);
  const eventsHook = useEvents();

  return (
    <Animate>

      <FetchEvents
        search={search}
        setLoading={x => setLoading(x)}
        setData={x => setEvents(x)}
      />

      <CustomSearch
        search
        data={events?.results}
        loading={loading}
        setFilter={x => setFilter(x)}
        searchableDropdownData={
          [
            {
              label: 'Event',
              name: 'event',
              placeholder: ' event name',
              options: eventsHook?.data?.list
            },
          ]
        }
      />

      <Card>
        <Table
          loading={loading}
          data={filter ? filter : events?.results}
          badge={{ col: 'total_triggers', color: 'blue' }}
          show={['name', 'total_triggers']}
          actions={{

            view: { url: '/events', col: 'name' }

          }}
        />
      </Card>
    </Animate>
  )
}

function FetchEvents(props) {

  const events = useAPI(`/api/event?search=${props.search}&group=name`);

  useEffect(() => {

    props.setLoading(events.loading);

    if (events.data)
      props.setData(events.data);

  }, [events, props])

  return false;

}